export const mixpanelConfig = {
  key: window["env"]["mixpanelKey"] || ""
};
